
export class QuestionAttachment{
    public AttachmentID?: number;
    public FileName: string;
    public GUID: string;
    public Length: number;
    public MimeType: string;
    //FE Only
    public CanDownload:boolean = false;
    constructor(values: Object = {}){
        Object.assign(this, values);
    }

}
